import { DataStoreTypes } from "../constants";
// data store for creating a new account
import { mkDataStore } from "../redux";

const store = mkDataStore("signupparameters", DataStoreTypes.Keyless);

export const signupParametersReducer = store.reducer;
export const signupParametersActions = store.actions;
export const signupParametersSelector = store.selector;
